import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { motion } from "framer-motion";
import logisticsImg from "../../static/media/services/logistics.webp";

const items = [
  {
    title: "Gestión eficiente de suministros y materiales:",
    description:
      "Aseguramos el manejo adecuado, almacenamiento y distribución de materiales para tus proyectos, minimizando costos y tiempos de entrega.",
  },
  {
    title: "Transporte seguro y puntual:",
    description:
      "Coordinamos el traslado de equipos y materiales con unidades confiables, asegurando entregas oportunas y en óptimas condiciones.",
  },
  {
    title: "Apoyo logístico integral para obras e instalaciones:",
    description:
      "Nos encargamos de la planificación, abastecimiento y soporte logístico completo para garantizar el éxito de tus operaciones técnicas.",
  },
];

const LogisticsServices = () => {
  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        px: 4,
        py: 8,
        backgroundColor: "#004aad",
      }}
    >
      <motion.div
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
        style={{ width: "100%", maxWidth: 500 }}
      >
        <Box
          component="img"
          src={logisticsImg}
          alt="Servicios de logística"
          sx={{
            width: { xs: "90%", sm: "100%" },
            maxWidth: 500,
            borderRadius: "16px",
            objectFit: "contain",
            display: "block",
            mx: "auto",
          }}
        />
      </motion.div>

      <Box sx={{ width: { xs: "100%", md: "55%" }, color: "#ffffff" }}>
        <Typography
          component="h2"
          sx={{
            fontWeight: 700,
            mb: 3,
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.4rem" },
            color: "#ffffff",
          }}
        >
          Servicios de Logística en Materiales
        </Typography>

        <List disablePadding>
          {items.map((item, index) => (
            <ListItem key={index} sx={{ alignItems: "flex-start", px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5, minWidth: 36 }}>
                <LocalShippingIcon sx={{ color: "#ffffff" }} />
              </ListItemIcon>

              <ListItemText
                primary={
                  <Typography
                    component="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: "1rem",
                      color: "#ffffff",
                    }}
                  >
                    {item.title}
                  </Typography>
                }
                secondary={
                  <Typography
                    component="p"
                    sx={{
                      fontSize: "0.95rem",
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    {item.description}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Box sx={{ display: "flex", mt: 4 }}>
            <Button
              component="a"
              href="https://wa.me/593991911882"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: { xs: "0.9rem", sm: "1rem" },
                fontWeight: 700,
                color: "#004aad",
                backgroundColor: "#ffffff",
                borderRadius: "999px",
                textTransform: "none",
                transition: "all .2s ease",
                "&:hover": {
                  backgroundColor: "#e6ecff",
                  transform: "translateY(-2px)",
                },
              }}
            >
              CONTÁCTANOS
            </Button>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default LogisticsServices;
